import { styled } from "styled-components";

export const MyPersonalColor = styled.span`
  font-size: 18px;

  margin-left: 8px;
`;
